<div class="layout-breadcrumb-container">
  <nav class="layout-breadcrumb">
    <ol>
      <li><i class="pi pi-home"></i></li>
      @for (item of breadcrumbs$ | async; track item.label; let last = $last) {
        <li><i class="pi pi-angle-right"></i></li>
        <li>
          <span>{{ item.label | i18next }}</span>
        </li>
      }
    </ol>
  </nav>
</div>
